<template>
  <div class="bg-292a2e p-relative">
    <div class="header container flex align-center justify-space-between">
      <div class="flex align-center">
        <span class="color-94 font-12 cursor" @click="toLigin" v-if="!isLogin">登录</span>
        <span class="color-94 font-12" v-else>{{user.username || '-'}} <span @click="toQuit" class="cursor">退出</span></span>
        <div class="line"></div>
        <span class="color-94 font-12 cursor" @click="toRegister">注册</span>
      </div>
      <div class="flex align-center">
        <span class="color-94 font-12">鲁班兄弟</span>
        <div class="line"></div>
        <img src="/images/tel.png" alt="" class="mr-4 ">
        <span class="color-94 font-12">咨询热线：</span>
        <span class="color-94 font-16 font-arial">4007-123-123</span>
      </div>
    </div>
    <div class="header-hr mb-60"></div>
    <div class="bg-292a2e menu" :class="isFixed ? 'fixed' : ''">
      <div class="nav container flex align-center">
        <img src="/images/logoshang.png" alt="">
        <div class="flex nav-menu flex-1">
          <div v-for="item in nav" :key="item.name">
            <router-link class="router-link-active font-16 font-yahei" :class="title === item.name ? 'active' : 'color-ff'" :to="{path:item.href}">{{item.name}}</router-link>
          </div>
          <div>
            <div class="router-link-active font-16 font-yahei" :class="title === '我的方案' ? 'active' : 'color-ff'" @click="toMyScheme">我的方案</div>
          </div>
        </div>
        <div class="search" v-if="title !== '首页'">
          <el-input v-model="input" placeholder="搜索方案/商品/品牌/案例" @keyup.enter.native="search" @clear="search" clearable class="flex-1 h-100"></el-input>
          <el-button icon="el-icon-search" circle class="h-100" @click="search"></el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Index",
  props: ['title', 'isFixed'],
  components: {},
  data () {
    return {
      nav: [{
        name: '首页',
        href: '/index.html'
      }, {
        name: '整装方案',
        href: '/overallScheme.html'
      }, {
        name: '选商品',
        href: '/Goods.html'
      }, {
        name: '找品牌',
        href: '/Brand.html'
      }, {
        name: '看案例',
        href: '/Case.html'
      }],
      input: '',
      isLogin: this.$store.state.token,
      user: this.$store.state.user
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    toLigin () {
      this.$store.dispatch('setLogin', true);
    },
    toMyScheme () {
      if (this.isLogin) {
        this.$router.push({path: '/myScheme.html'})
      } else {
        this.toLigin()
      }
    },
    toQuit () {
      this.$store.dispatch('removeUser')
      this.$store.dispatch('setLogin', true);
      this.$router.push({path: '/index.html'})
      this.isLogin = this.$store.state.token
    },
    toRegister () {
      this.$parent.isRegister = true
       this.$store.dispatch('setLogin', false);
    },
    search () {
      this.$parent.keywords = this.input
    }
  },
  watch: {
    user (val) {
      this.user = val
    }
  }
};
</script>

<style lang="scss" scoped>
  .header{
    height: 30px;
  }
  .nav{
    height: 60px;
  }
  .line{
    height: 12px;
    width: 1px;
    background: rgba($color: #fff, $alpha: 0.1);
    margin: 0 10px;
  }
  .header-hr{
    height: 1px;
    background: #343539;
  }
  .nav-menu > div{
    margin-left: 50px;
    cursor: pointer;
    position: relative;
    &:hover a{
      color: #c19357;
    }
    &:after{
      position: absolute;
      width: 100%;
      height: 2px;
      background: transparent;
      bottom: -4px;
      left: 0;
      display: block;
      content: '';
    }
    &:hover:after{
      background: #c19357;
    }
  }
  .nav-menu .active{
    color: #c19357;
    position: relative;
    &:after{
      position: absolute;
      width: 100%;
      height: 2px;
      background: #c19357;
      bottom: -4px;
      left: 0;
      display: block;
      content: '';
    }
  }
  .search{
    width: 225px;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    height: 30px;
    background: #fff;
    display: flex;
    margin-right: 15px;
  }
  .menu{
    width: 100%;
    position: absolute;
    top: 31px;
    transition: all 0s;
  }
  .fixed{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
  }
  ::v-deep{
    .el-input__inner{
      height: 100%;
      line-height: 30px;
      font-size: 12px;
      border: 0;
      background: transparent;
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus{
      border: 0;
    }
    .el-input__suffix{
      margin-top: -5px;
    }
    .search .el-button{
      padding: 0;
      width: 30px;
      background: #c19357;
      color: #fff;
      border-color: #c19357;
      margin-right: -15px;
    }
  }
</style>
